// Mock data for IP Protection Center website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "E-commerce Business Owner",
    content: "IP Protection Center made the trademark registration process incredibly smooth. Their team was professional and kept me informed every step of the way. Highly recommend!",
    rating: 5
  },
  {
    id: 2,
    name: "James Rodriguez",
    role: "Tech Startup Founder",
    content: "I was worried about the complexity of trademark registration, but IP Protection Center handled everything perfectly. Great service and reasonable pricing!",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Chen",
    role: "Fashion Designer",
    content: "Protected my brand quickly and efficiently. The comprehensive search report gave me peace of mind. Excellent customer support throughout!",
    rating: 5
  },
  {
    id: 4,
    name: "Michael Thompson",
    role: "Restaurant Chain Owner",
    content: "Professional, fast, and reliable. IP Protection Center secured our trademark without any hassle. Worth every penny!",
    rating: 5
  },
  {
    id: 5,
    name: "Lisa Anderson",
    role: "Digital Marketing Agency",
    content: "The Amazon Brand Registry service was a game-changer for our clients. IP Protection Center delivered exceptional results!",
    rating: 5
  },
  {
    id: 6,
    name: "David Martinez",
    role: "Software Development Company",
    content: "Outstanding service from start to finish. The team was knowledgeable and made the entire trademark process hassle-free. Couldn't be happier!",
    rating: 5
  },
  {
    id: 7,
    name: "Jennifer Wallace",
    role: "Fitness Brand Founder",
    content: "IP Protection Center helped us protect our fitness brand name and logo. Their expertise in trademark law gave us confidence in our brand protection strategy.",
    rating: 5
  },
  {
    id: 8,
    name: "Robert Parker",
    role: "Real Estate Developer",
    content: "Excellent communication and professional service. They guided us through copyright registration for our marketing materials with ease.",
    rating: 5
  },
  {
    id: 9,
    name: "Amanda Foster",
    role: "Beauty Products Line",
    content: "The comprehensive trademark search saved us from potential legal issues. IP Protection Center's attention to detail is impressive. Highly professional team!",
    rating: 5
  },
  {
    id: 10,
    name: "Christopher Lee",
    role: "Mobile App Developer",
    content: "Fast, efficient, and knowledgeable. They handled our trademark registration and helped us protect our app name. Great experience overall!",
    rating: 5
  },
  {
    id: 11,
    name: "Patricia Hughes",
    role: "Organic Food Company",
    content: "IP Protection Center provided exceptional service for our company formation and trademark needs. Their expertise made the process seamless!",
    rating: 5
  },
  {
    id: 12,
    name: "Daniel Brooks",
    role: "Photography Studio Owner",
    content: "Copyright registration was quick and straightforward. The team answered all my questions and provided excellent guidance throughout the process.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Submit Your Information",
    description: "Complete our simple form with your trademark details. Our team reviews your submission within 24 hours.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Comprehensive Search & Review",
    description: "We conduct a thorough trademark search and analyze potential conflicts to ensure your application success.",
    icon: "Search"
  },
  {
    id: 3,
    title: "Filing & Protection",
    description: "We file your application with the USPTO and monitor it until your trademark is secured and protected.",
    icon: "Shield"
  }
];

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    slug: "trademark-registration",
    description: "Secure your brand identity with comprehensive trademark registration services. Protect your business name, logo, and intellectual property.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Copyright Registration",
    slug: "copyright-registration",
    description: "Protect your original creative works, including literary, artistic, and digital content with official copyright registration.",
    icon: "BookOpen"
  },
  {
    id: 3,
    title: "Trademark Comprehensive Search",
    slug: "trademark-comprehensive-search",
    description: "Detailed trademark search to identify potential conflicts before filing. Reduce rejection risks with our expert analysis.",
    icon: "SearchCheck"
  },
  {
    id: 4,
    title: "Company Formation",
    slug: "company-formation",
    description: "Complete business formation services including LLC, Corporation setup, and all necessary documentation.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    slug: "amazon-brand-registry",
    description: "Get your brand registered on Amazon to unlock enhanced protection, advertising tools, and brand control.",
    icon: "ShoppingBag"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic",
    price: "$349",
    government_fee: "+ USPTO filing fee",
    description: "",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secure",
      "100% Satisfaction Guarantee"
    ],
    note: "Government filing fee not included",
    buttonText: "Get Started",
    recommended: false
  },
  {
    id: 2,
    name: "Standard",
    price: "$399",
    government_fee: "+ USPTO filing fee",
    description: "",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee",
      "Refusal Risk Meter"
    ],
    note: "Government filing fee not included",
    buttonText: "Get Started",
    recommended: false
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$449",
    government_fee: "+ USPTO filing fee",
    description: "",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "Government filing fee not included",
    buttonText: "Get Started",
    recommended: true
  },
  {
    id: 4,
    name: "Platinum",
    price: "$549",
    government_fee: "+ USPTO filing fee",
    description: "",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "100% Satisfaction Guarantee",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "100% Approval Guarantee",
      "Comprehensive Trademark Search Report (Federal & State)",
      "24-hour Expedited Service",
      "Cease & Desist Letter"
    ],
    note: "Government filing fee not included",
    buttonText: "Get Started",
    recommended: false
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does trademark registration take?",
    answer: "The trademark registration process typically takes 8-12 months from filing to approval. We handle all communications with the USPTO and keep you updated throughout the entire process."
  },
  {
    id: 2,
    question: "What's included in the government filing fee?",
    answer: "The USPTO charges a government filing fee of $250-$350 per class of goods/services. This fee is separate from our service fees and is paid directly to the government."
  },
  {
    id: 3,
    question: "Can I trademark a name that's similar to an existing one?",
    answer: "It depends on several factors including industry, geography, and similarity. Our comprehensive search service identifies potential conflicts and our experts provide guidance on your application's likelihood of success."
  },
  {
    id: 4,
    question: "What happens if my application is rejected?",
    answer: "Our packages include expert review to minimize rejection risk. If an office action is issued, our team will work with you to respond appropriately. Premium packages include additional support for handling objections."
  },
  {
    id: 5,
    question: "Do I need a trademark for my business?",
    answer: "A trademark protects your brand identity and prevents others from using similar names or logos in your industry. It's essential for building brand value and legal protection as your business grows."
  }
];

export const countries = [
  { code: "+1", name: "United States", countryCode: "US" },
  { code: "+1", name: "Canada", countryCode: "CA" },
  { code: "+44", name: "United Kingdom", countryCode: "GB" },
  { code: "+61", name: "Australia", countryCode: "AU" },
  { code: "+91", name: "India", countryCode: "IN" },
  { code: "+86", name: "China", countryCode: "CN" },
  { code: "+81", name: "Japan", countryCode: "JP" },
  { code: "+49", name: "Germany", countryCode: "DE" },
  { code: "+33", name: "France", countryCode: "FR" },
  { code: "+39", name: "Italy", countryCode: "IT" },
  { code: "+31", name: "Netherlands", countryCode: "NL" },
  { code: "+92", name: "Pakistan", countryCode: "PK" },
  { code: "+971", name: "United Arab Emirates", countryCode: "AE" },
  { code: "+966", name: "Saudi Arabia", countryCode: "SA" },
  { code: "+27", name: "South Africa", countryCode: "ZA" }
];